import React from "react";
import { Space, Table, Tag } from 'antd';

export default function Timeseriestable () {
    const columns = [
        {
          title: 'Time',
          dataIndex: 'time',
          key: 'time',
        },
        {
          title: 'Tag1',
          dataIndex: 'tag1',
          key: 'tag1',
        },
        {
          title: 'Tag2',
          dataIndex: 'tag2',
          key: 'tag2',
        }
    ]

    const data = [
        {
          key: '1',
          time: '28-10-2024 17:39:10',
          tag1: 32,
          tag2: 42                          
        },
        {
          key: '2',
          time: '28-10-2024 17:50:10',
          tag1: 12,
          tag2: 32   
        },
        {
          key: '3',
          time: '28-10-2024 17:55:10',
          tag1: 14,
          tag2: 55   
        },
    ];

    return(
        <div style={{height: '100%', width: '100%',  overflow: 'auto'}}>
            <Table columns={columns} dataSource={data}/>
        </div>
    )
}